import React from 'react';
import ReactDOM from 'react-dom';
import hasParentWithClassName from '@lib/hasParentWithClassName'
import _ from 'lodash';

class TooltipPortal extends React.Component {

    constructor(props) {
        super(props)
        const id = _.uniqueId();
        this.el = document.getElementById(id)

        if (this.el === null) {
            this.el = document.createElement('div')
            this.el.setAttribute('id', id)
            document.body.appendChild(this.el)
        }

        this.el.setAttribute('class', 'tooltip-portal-content tooltip-light-dropdown tooltip-style-' + this.props.style)
    }

    componentDidMount() {
        let rect = this.props.rootRef.getBoundingClientRect()
        this.el.style.top = (rect.top + window.pageYOffset) + 'px';
        this.el.style.left = rect.left + 'px';
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        )
    }
}

export default class LightDropdown extends React.Component {
    state = {
        visible: false
    }

    constructor(props) {
        super(props)
        this.rootRef = React.createRef()
    }

    onClick = e => {
        this.setState({
            visible: true
        }, () => {
            if (this.state.visible) {
                window.addEventListener('click', this.onWindowClick, true)
            } else {
                window.removeEventListener('click', this.onWindowClick)
            }
        })
    }

    onWindowClick = e => {
        if (!hasParentWithClassName(e.target, 'tooltip-portal-content')) {
            this.setState({visible: false})
            window.removeEventListener('click', this.onWindowClick)
        }
    }

    onItemClick(item) {
        this.props.onItemClick(item);
        window.removeEventListener('click', this.onWindowClick);
        this.forceUpdate();
    }

    render() {
        var self = this;
        return (
            <div className="tooltip-portal" onClick={this.onClick} ref={this.rootRef}>
                <div className="light-dropdown-icon">
                    <img src={this.props.icon}/>
                </div>

                {this.state.visible && (
                    <TooltipPortal style={this.props.style} rootRef={this.rootRef.current}>
                        <ul>
                            {this.props.items.map(item => (
                                <li key={item.id} onClick={() => {
                                    self.setState({visible: false})
                                    self.onItemClick(item);
                                }}>{item.label}</li>
                            ))}
                        </ul>
                    </TooltipPortal>
                )}
            </div>
        )
    }
}